import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { Button, FullScreenModal, Loader } from '@basic';
import { useGoalSubscriptionService } from '@hooks';
import { GoalSubscriptionModel } from '@models';
import { useStore } from '@store';
import { setupForDark } from '@theme';
import { useEffect, useState } from 'react';
import { GoalLogo } from '../goals';

function GoalSubscriptionStrategyFinishedModal() {
  const { t } = useTranslation();
  const { getGoalSubscription, isPendingGetGoalSubscription } = useGoalSubscriptionService();
  const {
    goalSubscriptionStrategyFinishedModalState,
    setGoalSubscriptionStrategyFinishedModalState
  } = useStore((state) => ({
    goalSubscriptionStrategyFinishedModalState: state.goalSubscriptionStrategyFinishedModalState,
    setGoalSubscriptionStrategyFinishedModalState:
      state.setGoalSubscriptionStrategyFinishedModalState
  }));
  const [goalSubscription, setGoalSubscription] = useState<GoalSubscriptionModel | null>(null);

  useEffect(() => {
    if (goalSubscriptionStrategyFinishedModalState.goalSubscriptionId) {
      getGoalSubscription(goalSubscriptionStrategyFinishedModalState.goalSubscriptionId).then(
        (goalSubscription) => {
          setGoalSubscription(goalSubscription);
        }
      );
    } else {
      setGoalSubscription(null);
    }
  }, [goalSubscriptionStrategyFinishedModalState]);

  const onClose = () => {
    setGoalSubscriptionStrategyFinishedModalState({
      isOpen: false,
      goalSubscriptionId: null
    });
    setGoalSubscription(null);
  };

  return (
    <FullScreenModal isOpen={goalSubscriptionStrategyFinishedModalState.isOpen} onClose={onClose}>
      {!goalSubscription || isPendingGetGoalSubscription ? (
        <div className='flex items-center justify-center h-full'>
          <Loader />
        </div>
      ) : (
        <div className={classNames('mb-xl dk:mt-huge')}>
          <div
            className={classNames(
              'flex flex-col items-center justify-center gap-sm',
              'dk:gap-huge'
            )}
          >
            <div className='my-xl'>
              <GoalLogo
                logoSvg={goalSubscription?.goal?.logoSvg}
                size={76}
                status={goalSubscription?.status}
              />
            </div>
            <div className='px-xxxl text-center'>
              <div className={classNames('H4 mb-xl', setupForDark('text-primary'), 'dk:H3')}>
                {t('components.goalSubscriptionStrategyFinishedModal.onCompleted')}
              </div>
              <div className={classNames('P2R', setupForDark('text-tertiary'))}>
                {goalSubscription?.goal?.title}
              </div>
            </div>
          </div>
          <div
            className={classNames(
              'absolute bottom-[50px] flex flex-col items-center px-xl w-full',
              'dk:mx-auto dk:max-w-screen-md dk:px-huge'
            )}
          >
            <div className='w-[200px]'>
              <Button type='tertiary' size='large' onClick={onClose}>
                {t('general.close')}
              </Button>
            </div>
          </div>
        </div>
      )}
    </FullScreenModal>
  );
}

export default GoalSubscriptionStrategyFinishedModal;
